import { render, staticRenderFns } from "./order-total.vue?vue&type=template&id=f6a19e1a&scoped=true&"
import script from "./order-total.vue?vue&type=script&lang=js&"
export * from "./order-total.vue?vue&type=script&lang=js&"
import style0 from "./order-total.vue?vue&type=style&index=0&id=f6a19e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a19e1a",
  null
  
)

export default component.exports